import "./DedicatedServiceAndLocation.module.css";
import Header from "@/reusable_sections/Header";
import PageIntroduction from "./sections/PageIntroduction";
import ServiceExplanationBenefits from "./sections/ServiceExplanationBenefits";
import WhoWeAdvise from "./sections/WhoWeAdvise";
import Benefits from "./sections/Benefits";
import ScheduleAFreeConsultation from "./sections/ScheduleAFreeConsultation";
import Footer from "@/reusable_sections/Footer";
export default function DedicatedServiceAndLocationPage() {
  return <div>
      <Header />
      <PageIntroduction />
      <ServiceExplanationBenefits />
      <WhoWeAdvise />
      <Benefits />
      <ScheduleAFreeConsultation />
      <Footer />
    </div>;
}